import React, {FC} from "react";
import {Money as MoneyModel, PrimaryMarketProject, translateProjectStatus} from "api-client";
import {BoldText, CustomLink, Image, Money} from "components/common";
import styles from './PrimaryMarketOffer.module.scss';
import {formatDate, formatPercents} from "../../../../../formatters";
import paymentHistory from 'assets/images/svg/payment-history.svg';
import {RouteDictionary} from "../../../../../utils";
import ProjectTypeBadge from "../../ProjectTypeBadge";

interface Props {
    project: PrimaryMarketProject;
  setModalActive: (active: boolean) => void;
}

const PrimaryMarketOffer: FC<Props> = ({project, setModalActive}) => {
  return <li className={styles.primaryMarketOffer}>
    <CustomLink to={RouteDictionary.DETAILED_PROJECT} params={{uuid: project.uuid}} className={styles.primaryMarketOffer__statusContainer}>
      <div className={styles.primaryMarketOffer__status}>
        {translateProjectStatus(project.status)}
      </div>
      <ProjectTypeBadge type={project.type}/>
    </CustomLink>
    <CustomLink
      to={RouteDictionary.DETAILED_PROJECT}
      params={{uuid: project.uuid}}
      className={styles.primaryMarketOffer__primary}
    >
      <BoldText>
        <div>{project.name[0].text}</div>
      </BoldText>
    </CustomLink>
    <CustomLink to={RouteDictionary.DETAILED_PROJECT} params={{uuid: project.uuid}} className={styles.primaryMarketOffer__sum}>
      <div className={styles.primaryMarketOffer__rowHeader}>
        Сумма
      </div>
      <div>
        <Money money={project.loan}/>
      </div>
    </CustomLink>
    <CustomLink to={RouteDictionary.DETAILED_PROJECT} params={{uuid: project.uuid}} className={styles.primaryMarketOffer__available}>
      <div className={styles.primaryMarketOffer__rowHeader}>
        Доступно
      </div>
      <div>
        <Money money={new MoneyModel(project.loan.amount - project.investedSum.amount, "RUB")}/>
      </div>
    </CustomLink>
    <CustomLink to={RouteDictionary.DETAILED_PROJECT} params={{uuid: project.uuid}} className={styles.primaryMarketOffer__yield}>
      <div className={styles.primaryMarketOffer__rowHeader}>
        Доходность
      </div>
      <div>
        {formatPercents(project.effectiveInterestRate)}
      </div>
    </CustomLink>
    <CustomLink to={RouteDictionary.DETAILED_PROJECT} params={{uuid: project.uuid}} className={styles.primaryMarketOffer__percent}>
      <div className={styles.primaryMarketOffer__rowHeader}>
        Ставка договора
      </div>
      <div>
        {formatPercents(project.interestRate)}
      </div>
    </CustomLink>
    <CustomLink to={RouteDictionary.DETAILED_PROJECT} params={{uuid: project.uuid}} className={styles.primaryMarketOffer__term}>
      <div className={styles.primaryMarketOffer__rowHeader}>
        Срок договора
      </div>
      <div>
        до {project.projectEndDate && formatDate(project.projectEndDate, 'MMM YYYY')}
      </div>
    </CustomLink>
    <div className={styles.primaryMarketOffer__history} onClick={() => setModalActive(true)}>
      <Image src={paymentHistory} alt='payment'/>
      <div className={styles.primaryMarketOffer__rowHeader}>
        Платежная история
      </div>
    </div>
  </li>;
}
;

export default PrimaryMarketOffer;